import { render, staticRenderFns } from "./QuickProductLinks.vue?vue&type=template&id=350b3f78"
import script from "./QuickProductLinks.vue?vue&type=script&lang=js"
export * from "./QuickProductLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports